import { render, staticRenderFns } from "./myTemplate.vue?vue&type=template&id=4aea7332"
import script from "./myTemplate.vue?vue&type=script&lang=js"
export * from "./myTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports